<template>
    <SparkListItem :config="config">
        <template
            v-if="unreadCount > 0"
            #end-item
        >
            <DBadge type="red-strong">
                {{ unreadCount }}
            </DBadge>
        </template>
    </SparkListItem>
</template>
<script setup>
    import { DBadge } from '@digistorm/spark'

    const props = defineProps({
        config: Object,
    })

    const notificationsStore = useNotificationsStore()
    const { unreadCount } = storeToRefs(notificationsStore)
</script>
